import { css } from '@emotion/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import Button from 'components/Buttons/Button';
import { Theme, themes } from 'containers/Sidebar/themes';
import { useSidebarStatus } from 'containers/Sidebar/useSidebarStatus';
import React from 'react';
import tw from 'twin.macro';

interface Props {
  theme: Theme;
}

export function ToggleChevron({ theme }: Props) {
  const { isOpen, toggle } = useSidebarStatus();

  return (
    <div
      css={[
        isOpen && tw`right-3`,
        !isOpen &&
          css`
            left: calc(100% - 45px);
          `,
        tw`absolute top-4 z-20`,
      ]}
    >
      <Button
        css={[
          tw`rounded-full px-1 py-0 border-transparent transform transition-all ease-in-out `,
          themes[theme].toggleChevron,
          isOpen && tw`hover:pr-4`,
          !isOpen && tw`hover:pl-4`,
        ]}
        small
        onClick={() => toggle()}
      >
        {isOpen && (
          <ChevronLeftIcon
            css={[tw`h-5 w-5`, themes[theme].toggleChevronIcon]}
          />
        )}
        {!isOpen && (
          <ChevronRightIcon
            css={[tw`h-5 w-5`, themes[theme].toggleChevronIcon]}
          />
        )}
      </Button>
    </div>
  );
}
